import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export type ColumnChartData = {
  name: string;
  value: number;
};

type ColumnChartProps = {
  data: ColumnChartData[];
  height?: number;
  color?: string;
  title?: string;
  titleFontSize?: string;
  labelsFontSize?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  plotLines?: Highcharts.YAxisPlotLinesOptions[] | undefined;
  extraSeries?: Highcharts.SeriesOptionsType;
  decimalNumber?: number;
};

const ColumnChart: React.FC<ColumnChartProps> = ({
  data,
  height,
  color = "#460F81",
  title,
  labelsFontSize,
  titleFontSize,
  xAxisTitle,
  yAxisTitle,
  plotLines,
  extraSeries,
  decimalNumber,
}) => {
  const options: Highcharts.Options = {
    chart: {
      type: "column",
      height,
    },

    title: {
      text: title || undefined,
      style: {
        fontSize: titleFontSize,
      },
    },
    xAxis: {
      categories: data?.map((d) => d.name),
      title: xAxisTitle ? { text: xAxisTitle } : undefined,
      labels: {
        step: 1,
        style: {
          fontSize: labelsFontSize,
        },
      },
    },

    yAxis: {
      title: yAxisTitle ? { text: yAxisTitle } : undefined,
      plotLines,
    },
    series: extraSeries
      ? [
          {
            type: "column",
            name: "مقدار",
            data: data?.map((d) => d.value),
            color,
            showInLegend: false,
          },
          extraSeries,
        ]
      : [
          {
            type: "column",
            name: "مقدار",
            data: data?.map((d) => d.value),
            color,
            showInLegend: false,
          },
        ],
    credits: { enabled: false },
    exporting: { enabled: false },
    navigation: { buttonOptions: { enabled: false } },
    legend: { enabled: false },
    plotOptions: {
      column: {
        dataLabels: { enabled: false, format: `{point.y:.${decimalNumber}f}` },
      },
    },
    tooltip: {
      formatter: function () {
        return `<span style="color:${this.point.color}">●</span> ${
          this.series.name
        }: <b>${this.point.y && this.point.y.toFixed(decimalNumber)}</b>`;
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ColumnChart;
